// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"99a0a4c6","204":"b8096a84","727":"538e95e9","765":"59586c48","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};